<script lang="ts">
  import {onMount} from 'svelte'
  import api from '../api/api'
  import DropdownWrapper from '../shared/DropdownWrapper.svelte'
  import Notifications from './Notifications.svelte'

  let hasNotice = false

  onMount(() => {
    loadNotificationPresence()
  })

  async function loadNotificationPresence() {
    hasNotice = (await api.get<{ count: number }>('/timelines/unread_count')).count > 0
  }
</script>

<DropdownWrapper class="ui item dropdown notifications {hasNotice ? 'has-notice' : ''}"
                 autoclose={false}
                 let:show>
  <i class="dropdown icon icon-p-bell"/>

  {#if show}
    <div class="menu transition visible">
      <Notifications onUpdated={() => loadNotificationPresence()}/>
    </div>
  {/if}
</DropdownWrapper>